import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { AngularMaterialModule } from '../../../core/modules/angular-material/angular-material.module'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { LoginService } from '../../../core/services/login/login.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Location } from '@angular/common'
import { AuthService } from '../../../core/services/auth/auth.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { PermissionService } from '../../../core/services/permission/permission.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

export interface Acao {
  id_crud: number;
  descricao: string;
  tem_permissao: number; // 0 ou 1
}

// Interface para cada módulo com suas ações
export interface ModuloPermissao {
  id_modulo: number;
  modulo: string;
  acoes: Acao[];
}

// Interface para a resposta completa da API
export interface PermissaoResponse {
  data: ModuloPermissao[]; // ou pode usar 'permissoes' dependendo da resposta
}

// Alternativa se a resposta vier com 'permissoes' como no seu JSON


@Component({
  imports: [AngularMaterialModule, ReactiveFormsModule, MatProgressSpinner],
  selector: 'reset-password-form',
  standalone: true,
  styleUrl: './reset-password-form.component.scss',
  templateUrl: './reset-password-form.component.html',
  providers: [LoginService, AuthService, PermissionService],
})
export class ResetPasswordFormComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private snackbarCustomService: SnackbarCustomService,
  ) {}

  @Output() forgotPassword = new EventEmitter<void>()
  hidePassword = true;
  hidePassword2 = true;

  loginForm: FormGroup = new FormGroup({})
  loading: boolean = false
  ngOnInit() {
    this.createForm()
    this.getTokenFromUrl()
  }
  token!: string
  removeTokenFromUrl() {
    this.location.replaceState('/reset-password')
  }

  getTokenFromUrl() {
    this.route.queryParams.subscribe(params => {
      if (params['token']) {
        this.token = params['token']

        // Remove o token da URL sem recarregar
        this.removeTokenFromUrl()
      }
    })
  }

  createForm() {
    this.loginForm = this.formBuilder.group({
      password: ['', [Validators.required]],
      new_password: ['', [Validators.required]],
    })
  }


  checkForm() {
    return this.loginForm.get('new_password')?.value && this.loginForm.get('password')?.value && this.loginForm.get('new_password')?.value === this.loginForm.get('password')?.value
  }


  sendLogin(): void {
    const loginData = {
      token: this.token,
      nova_senha: this.loginForm.get('new_password')?.value,
    }
    this.loading = true

    this.authService.resetPassword(loginData).subscribe({
      next: (response: any) => {
          this.router.navigate(['/login'])
      },
      error: (error) => {
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }
  getPermissions(permissoes: PermissaoResponse["data"]) {
    if(permissoes.length>0){
        this.authService.savePermissions(permissoes)
        this.router.navigate(['/home'])
        this.snackbarCustomService.success('Login realizado com sucesso!')
      } else{
        this.snackbarCustomService.error("Erro ao associar suas permissões")
      }
  }
}
